import { render, staticRenderFns } from "./BulkMenu.vue?vue&type=template&id=306cc03b"
import script from "./BulkMenu.vue?vue&type=script&lang=js"
export * from "./BulkMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports